import {Link, useLocation, useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {BsMoonStars, BsSun} from "react-icons/bs";
import {useAuthContext} from "../../../contexts/AuthContext";
import {useAppContext} from "../../../contexts/AppContext";
import {useTheme} from "../../../contexts/ThemeContext";
import {useQuestions} from "../../../contexts/QuestionsContext";
import {useApprovals} from "../../../contexts/ApprovalsContext";
import {usePermissions} from "../../../hooks/usePermissions";
import {getYearFromPath, getSection} from "../../../navigation/navConfig";
import styles from "./TopNav.module.css";

export const TopNav = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {setLocalStorageState} = useAuthContext();
    const {years} = useAppContext();
    const {isDark, toggleTheme} = useTheme();
    const {unanswered} = useQuestions();
    const {to_approve: toApprove, my_attention: myAttention} = useApprovals();
    const {canReports, canUpload, isAdmin} = usePermissions();

    const yearFromPath = getYearFromPath(location.pathname);
    const section = getSection(location.pathname);

    // Запомняме последната гледана година, за да я ползваме от началния екран.
    useEffect(() => {
        if (yearFromPath) {
            localStorage.setItem('lastYear', yearFromPath);
        }
    }, [yearFromPath]);

    const sortedYears = [...years].sort((a, b) => a.year - b.year);
    const lastYear = localStorage.getItem('lastYear');
    const fallbackYear = sortedYears.length > 0 ? String(sortedYears[sortedYears.length - 1].year) : '';
    const resolvedYear = yearFromPath || lastYear || fallbackYear;

    // При смяна на година запазваме секцията, но зарязваме дълбокия контекст.
    const goToYear = (y) => {
        if (section === 'companies') navigate(`/${y}/companies`);
        else if (section === 'reports') navigate(`/${y}/reports`);
        else navigate(`/${y}/settlements`);
    };

    const onBack = () => {
        if (window.history.state && window.history.state.idx > 0) navigate(-1);
        else navigate('/');
    };

    const onLogout = () => {
        setLocalStorageState({});
        navigate('/login');
    };

    const linkClass = (active, disabled) => {
        const cls = [styles.navBtn];
        if (active) cls.push(styles.active);
        if (disabled) cls.push(styles.disabled);
        return cls.join(' ');
    };

    return (
        <nav className={styles.topNav}>
            <div className={styles.left}>
                <div className="dropdown d-inline-block">
                    <button className={`${styles.navBtn} dropdown-toggle`} type="button"
                            data-bs-toggle="dropdown" aria-expanded="false">
                        {resolvedYear || 'Година'}
                    </button>
                    <ul className="dropdown-menu">
                        {sortedYears.map(y => (
                            <li key={y.year}>
                                <button className="dropdown-item" onClick={() => goToYear(y.year)}>
                                    {y.year}
                                </button>
                            </li>
                        ))}
                        <li><hr className="dropdown-divider"/></li>
                        <li>
                            <button className="dropdown-item" onClick={() => navigate('/')}>
                                Начална страница
                            </button>
                        </li>
                    </ul>
                </div>

                {resolvedYear && (
                    <Link className={linkClass(section === 'settlements')}
                          to={`/${resolvedYear}/settlements`}>
                        Землища
                        {/* К: замени, които чакат моето одобрение, и мои замени,
                            отказани отсреща. Второто е важното — при отказ нищо
                            не се отменя само, тоест ако авторът не разбере,
                            разминаването остава завинаги. */}
                        {toApprove > 0 && (
                            <span className="badge bg-warning text-dark ms-1"
                                  title="Замени, които чакат вашето одобрение">{toApprove}</span>
                        )}
                        {myAttention > 0 && (
                            <span className="badge bg-danger ms-1"
                                  title="Ваши замени, отказани или изтрити отсреща">{myAttention}</span>
                        )}
                    </Link>
                )}
                {resolvedYear && (
                    <Link className={linkClass(section === 'companies')}
                          to={`/${resolvedYear}/companies`}>Ползватели-редакция</Link>
                )}
                {resolvedYear && (
                    canReports
                        ? <Link className={linkClass(section === 'reports')}
                                to={`/${resolvedYear}/reports`}>Справки</Link>
                        : <span className={linkClass(false, true)} title="Нямате достъп">Справки</span>
                )}
                {canUpload
                    ? <Link className={linkClass(section === 'upload')} to="/data-upload">Първоначални данни</Link>
                    : <span className={linkClass(false, true)} title="Нямате достъп">Първоначални данни</span>}
                <Link className={linkClass(section === 'help')} to="/help">Помощ</Link>
                {isAdmin && (
                    <Link className={linkClass(section === 'admin')} to="/admin">
                        Администрация
                        {/* И2: неотговорени въпроси — вижда се без влизане в панела. */}
                        {unanswered > 0 && <span className="badge bg-danger ms-1">{unanswered}</span>}
                    </Link>
                )}
            </div>

            <div className={styles.right}>
                {/* И1: превключване светла/тъмна тема. Изборът се помни в браузъра
                    и преживява изход от системата. */}
                <button className={`${styles.navBtn} ${styles.iconBtn}`} onClick={toggleTheme}
                        type="button"
                        title={isDark ? "Светла тема" : "Тъмна тема"}
                        aria-label={isDark ? "Светла тема" : "Тъмна тема"}>
                    {isDark ? <BsSun/> : <BsMoonStars/>}
                </button>
                <button className={styles.navBtn} onClick={onBack}>Назад</button>
                <button className={`${styles.navBtn} ${styles.logout}`} onClick={onLogout}>Изход</button>
            </div>
        </nav>
    );
};
